import ComingSoon from "../../../components/ComingSoon";

export default function Bolon() {
  return <ComingSoon title="Bolon Coming Soon" />;
}
